import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ValidationSchemaType } from "../utils";

export function PdfGroupAsset(props: { dataList: ValidationSchemaType[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "GROUP ASSET", key: "group_asset", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.mr_group_code ?? "-",
    group_asset: item.mr_group_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="Group Asset" />;
}
